





























































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import store from '@/store/store';

import CreateTimelineModal from '../timelinelist/CreateTimelineModal.vue'
import MapView from './Map.vue'
import LeafletMapView from './LeafletMap.vue'
import { mapGetters } from 'vuex';
import Node from '@/models/Node'
import Timeline from '@/models/Timeline'
import TimelinePermissions from '@/views/timelinelist/TimelinePermissions.vue';
import TimelineCopier from '@/views/timelinelist/TimelineCopier.vue';
import Mutations from '@/store/mutations'
import BestFitText from "@/components/BestFitText.vue";
import ProjectServer from '../../models/ProjectServer';
import { PacketType } from '../../models/Packet';
import { MapNodeEditRequest } from '../../models/packets/MapNode';

@Component({
	components:
	{
		MapView,
		LeafletMapView,
		CreateTimelineModal,
		TimelinePermissions,
		TimelineCopier,
		BestFitText
	},
	computed: 
	{
		...mapGetters([
			'mapToTimeline',
			'timelines',
			'mapNodes',
			'checkTimelineCopying',
			'checkTimelineAdmin',
			'checkTimelineWrite',
			'checkTimelineRead',
			'nodes'
		])
	},
	recomputed: {
		projectData()
		{
			return JSON.parse((store.state as any).project.project.data);
		}
	}
})
export default class MapContainer extends Vue
{
	mapGeneration = 0;
	activeMapNode : Node | null = null;
	modalsInitialized : Boolean = false;
	modalTimeline : Timeline | null = null;
	deleteModalTitleInput : string =  '';
	incorrectDeleteModalTitleInput : Boolean =  false;
	
	mapChangeCallback : number = -1;
	createCallback : number = -1;
	editCallback : number = -1;
	destroyCallback : number = -1;

	mounted()
	{
		console.log('map container');
		let cb = ()=>{
			this.$recompute('projectData');
			++this.mapGeneration;
			this.$forceUpdate();
			console.log('forcing update');
			if (this.$refs.activeMap)
			{
				console.log('map force update');
				(this.$refs.activeMap as any).$forceUpdate();
			}
		};

		this.mapChangeCallback = ProjectServer.instance.registerCallback(PacketType.ChangeMapData, cb);
		this.createCallback = ProjectServer.instance.registerCallback(PacketType.MapNodeCreate, cb);
		this.editCallback = ProjectServer.instance.registerCallback(PacketType.MapNodeEdit, cb);
		this.destroyCallback = ProjectServer.instance.registerCallback(PacketType.MapNodeDestroy, cb);
	}

	beforeDestroy()
	{
		ProjectServer.instance.removeCallback(PacketType.ChangeMapData, this.mapChangeCallback);
		ProjectServer.instance.removeCallback(PacketType.MapNodeCreate, this.createCallback);
		ProjectServer.instance.removeCallback(PacketType.MapNodeEdit, this.editCallback);
		ProjectServer.instance.removeCallback(PacketType.MapNodeDestroy, this.destroyCallback);
	}

	get isMapNodeSelected() : Boolean 
	{
		return this.activeMapNode != null;
	}

	get selectedNodeID() : Number 
	{
		if (this.activeMapNode == null)
			return -1;
		return this.activeMapNode.nodeid;
	}
	get selectedNodeTitle() : String 
	{
		if (this.activeMapNode == null)
			return "Invalid Map Node";
		return this.activeMapNode.name;
	}

	get selectedTimelines() : Timeline[] 
	{
		if (this.activeMapNode == null)
		{
			return [];
		}
		
		let tids = (this as any).mapToTimeline.get(this.activeMapNode.nodeid) as Number[];
		if (!tids)
			return [];
		let arr : Timeline[] = [];
		for (var i = 0; i < tids.length; ++i)
		{
			arr.push((this as any).timelines.get(tids[i]));
		}

		// numeric == natural sort, base sensitivity == case insensitive
		arr.sort((a, b) => { return a.name.trim().localeCompare(b.name.trim(), undefined, { numeric: true, sensitivity: 'base'}); })

		return arr;
	}

	nodeClicked(node : Node) 
	{
		this.activeMapNode = node;

		setTimeout(() => {
			this.$nextTick(() =>
			{
				console.log(this.$refs.selectedNodeTitle);
				(this.$refs.selectedNodeTitle as any).focus();
			});
		}, 50);
	}

	bgClicked() 
	{
		this.activeMapNode = null;
	}

	createTimelineClicked() 
	{
		(this.$refs as any).createTimelineModal.show();
	}

	enterTimeline(tl : Timeline)
	{
		this.$router.push(`/app/project/timeline/${tl.id}`);
	}

	showModal(name : string)
	{
		if (!this.modalsInitialized)
		{
			this.modalsInitialized = true;
			this.$nextTick(()=>{
				(this.$refs[name] as any).show();
			})
			return;
		}
		(this.$refs[name] as any).show();
	}

	viewComments(tl : Timeline) 
	{
		this.modalTimeline = tl;
		this.showModal('commentsModal');
	}

	viewInfo(tl : Timeline) 
	{
		this.modalTimeline = tl;
		this.showModal('dataModal');
	}

	viewUsers(tl : Timeline) 
	{
		this.modalTimeline = tl;
		this.showModal('userEditModal');
	}

	copyTimeline(tl : Timeline) 
	{
		this.modalTimeline = tl;
		this.showModal('copyModal');
	}

	deleteTimeline(tl : Timeline) 
	{
		this.modalTimeline = tl;
		this.showModal('deleteModal');
	}

	hideDeleteModal()
	{
		(this.$refs.deleteModal as any).hide();
		this.incorrectDeleteModalTitleInput = false;
	}

	confirmTimelineDelete()
	{
		if (this.modalTimeline != null)
		{
			if (this.deleteModalTitleInput == this.modalTimeline.name)
			{
				this.$store.commit(Mutations.deleteTimeline, { timelineid : this.modalTimeline.id });
				this.hideDeleteModal();
			}
			else
			{
				this.incorrectDeleteModalTitleInput = true;
			}
		}
	}

	timelinenodes(tl : Timeline) : Node[]
	{
		var tlnodes = []
		for (const nodeid of tl.nodeIDs)
		{
			//console.log(nodeid);
			tlnodes.push((this as any).nodes.get(nodeid));
		}
		return tlnodes;
	}

	minTime(tl : Timeline) : Date | null
	{
		let min = null;
		for (const node of this.timelinenodes(tl))
		{
			if (min == null || node.dateStart < min)
			{
				min = node.dateStart;
			}
		}
		return min;
	}

	maxTime(tl : Timeline) : Date | null
	{
		let max = null;
		for (const node of this.timelinenodes(tl))
		{
			if (max == null || node.dateEnd > max)
			{
				max = node.dateEnd;
			}
		}
		return max;
	}
}
